export function ethDateFormatter(ethDate) {
    const ethiopianMonths = [
        'ጳጉሜ', 'መስከረም', 'ጥቅምት', 'ህዳር', 'ታህሳስ', 'ጥር', 'የካቲት',
        'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ'
    ];
    // const ethiopianDays = [
    //     'እሑድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ'
    // ];

    const ethiopianYear = ethDate.year;
    const ethiopianMonth = ethiopianMonths[ethDate.month];
    const ethiopianDate = ethDate.date;
    // const ethiopianDay = ethiopianDays[ethDate.date % 7];

    return `${ethiopianMonth} ${ethiopianDate}, ${ethiopianYear}`;
}

export function ethDateFormatterForChat(ethDate) {
    const ethiopianMonths = [
        'ጳጉሜ', 'መስከረም', 'ጥቅምት', 'ህዳር', 'ታህሳስ', 'ጥር', 'የካቲት',
        'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ'
    ];

    const ethiopianDays = [
         'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ', 'እሑድ'
    ];

    const ethiopianYear = ethDate.year;
    const ethiopianMonth = ethiopianMonths[ethDate.month];
    const ethiopianDate = ethDate.date;
    const ethiopianDay = ethiopianDays[ethDate.date % 7];
    const hour = ethDate.hour < 10 ? ethDate.hour : ethDate.hour;
    const minute = ethDate.minute < 10 ? ethDate.minute : ethDate.minute;

    return `[${ethiopianDay}, ${ethiopianMonth} ${ethiopianDate}, ${ethiopianYear} ${hour}:${minute}]`;
}

export function ethMonthFormatter(ethDate) {
    const ethiopianMonths = [
      'ጳጉሜ', 'መስከረም', 'ጥቅምት', 'ህዳር', 'ታህሳስ', 'ጥር', 'የካቲት',
      'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ'
    ];
  
    const ethiopianYear = ethDate.year;
    const ethiopianMonth = ethiopianMonths[ethDate.month];
  
    if (!ethiopianMonth) {
      console.error('Invalid month index:', ethDate.month);
      return 'Invalid Date';
    }
  
    return `${ethiopianMonth}, ${ethiopianYear}`;
  }
  
